import Api from "@/services/Api";

export default {
  getList(dt) {
    return Api().get("/guiitm" + (dt ? "?" + dt : ""));
  },
  getTree(dt) {
    return Api().get("/guiitm/tree" + (dt ? "?" + dt : ""));
  },
  getItm(id) {
    return Api().get("/guiitm/" + id);
  },
  newItm(dt) {
    return Api().post("/guiitm", dt);
  },
  updItm(itm) {
    return Api().put("/guiitm/" + itm.id, itm);
  },
  delItm(id) {
    return Api().delete("/guiitm/" + id);
  },
  delItms(dt) {
    return Api().post("/guiitm/multiDel", dt);
  },
  addPlItems(dt) {
    return Api().post("/guiitm/" + dt.id + "/addPlItems", dt.plItems);
  },
  updPlItems(dt) {
    return Api().post("/guiitm/" + dt.id + "/updPlItems", dt.plItems);
  },
  getChildren(dt) {
    return Api().get("/guiitm/" + dt.id + "/childs");
  },
  moveToLeftOf(dt) {
    return Api().get("/guiitm/moveToLeftOf?src=" + dt.src + "&dst=" + dt.dst);
  },
  moveToRightOf(dt) {
    return Api().get("/guiitm/moveToRightOf?src=" + dt.src + "&dst=" + dt.dst);
  },
  addGuiMediaPlaylistItems(dt) {
    return Api().post("/guimediaplaylist/" + dt.id + "/addPlItems", dt.plItems);
  },
  updGuiMediaPlaylistItems(dt) {
    return Api().post("/guimediaplaylist/" + dt.id + "/updPlItems", dt.plItems);
  }
};
